<ng-container *ngIf="page">
  <ng-container
    *ngIf="!isEditMode || placement || directCaveats.length; else previewBlock"
  >
    <div edsGrid>
      <div edsRow>
        <div
          edsCol
          [attr.id]="
            importantLegalTitle?.length ? 'important-legal-info' : null
          "
        >
          <eds-legal [title]="importantLegalTitle" [hasSection]="true">
            <ng-container *ngIf="isSiteIntl">
              <div
                class="legal-caveats__container"
                *ngFor="let paragraph of legals"
                [innerHTML]="paragraph"
              ></div>
            </ng-container>
            <ng-container *ngIf="!isSiteIntl">
              <div
                *ngFor="let paragraph of legals"
                [innerHTML]="paragraph"
                class="small"
              ></div>
            </ng-container>
          </eds-legal>

          <eds-legal *ngIf="footnotes?.length" [title]="footnotesTitle">
            <ol class="list--ordered" *ngIf="isSiteIntl">
              <li
                *ngFor="let footnote of footnotes; let i = index"
                [innerHTML]="footnote"
                id="footnote{{ i + 1 }}"
                edsListItem
              ></li>
            </ol>
            <ol class="list--ordered" *ngIf="!isSiteIntl">
              <li
                *ngFor="let footnote of footnotes; let i = index"
                [innerHTML]="footnote"
                edsListItem
                id="footnote{{ i + 1 }}"
                class="small"
              ></li>
            </ol>
          </eds-legal>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-template #previewBlock>
  <h5>Legal Caveats Component - {{ placement }}</h5>
</ng-template>
